var displayOnSmallMultiSelectFilter = function () {
    return function (input) {
        var output = input;
        if (output.length > 15) {
            return output.substring(0, 15) + "...";
        }
        else {
            return output;
        }
    };
};
var ɵ0 = displayOnSmallMultiSelectFilter;
export var DisplayOnSmallMultiSelectFilter = {
    name: 'displayOnSmallMultiSelectFilter',
    filter: displayOnSmallMultiSelectFilter
};
export { ɵ0 };
//# sourceMappingURL=fourdotfive-display-on-small-multi-select.filter.js.map